import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { FinanciacionForm } from '../components/forms/FinanciacionForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { VehicleCard } from '../components/VehicleCard';
import { useVehicles } from '../contexts/VehiclesContext';
const beneficios = ['Asesoramiento personalizado', 'Opciones para 0KM', 'Evaluación rápida', 'Toma de usado como parte de pago', 'Consulta sin compromiso'];
export function Financiacion() {
  const [params] = useSearchParams();
  const {
    vehicles
  } = useVehicles();
  useSeo('Financiación y 0KM | VCARS', 'Accedé a tu próximo 0KM con asesoramiento personalizado: planes, cuotas y toma de usado como parte de pago.');
  const cero = vehicles.filter(v => v.estado === '0KM').slice(0, 3);
  return <main className="bg-ink" data-id="element-689" data-mp="1i6yqqd97z9ow">
      <div className="border-b border-line bg-surface" data-id="element-690" data-mp="1i7qnhrejzdgr">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.1fr_1fr] md:px-8 md:py-20" data-id="element-691" data-mp="1m8alex6yal3y">
          <div data-id="element-692" data-mp="1r6u8x21704yf">
            <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-693" data-mp="1r73wkiyrm00y">
              Financiación y 0KM
            </h1>
            <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-694" data-mp="1w43w0b1404j3">
              Accedé a tu próximo 0KM con asesoramiento personalizado.
            </p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-695" data-mp="255twe6cyydt0">
              Te ayudamos a encontrar la mejor opción según tu presupuesto, necesidad y
              perfil. Consultá planes, cuotas y alternativas de financiación.
            </p>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-696" data-mp="2jwaw9l9ygvns">
              {beneficios.map(b => <li key={b} className="flex items-start gap-2.5 text-[15px] text-white/90" data-id="element-697" data-mp="2ouvwhkp7jfc8">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-698" data-mp="1z6qjatujkb1m" />
                  {b}
                </li>)}
            </ul>
            <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" className="mt-8" data-id="element-699" data-mp="1u5sqlnbwnylv">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-700" data-mp="244ibzq30g16v" />
              Hablar con un vendedor
            </ButtonAnchor>
          </div>
          <FinanciacionForm vehiculoInicial={params.get('vehiculo') ?? ''} data-id="element-701" data-mp="2cyn4sf1pfmp1" />
        </div>
      </div>

      <section className="mx-auto w-full max-w-7xl px-5 py-16 md:px-8" data-id="element-702" data-mp="2rw77tgf1j7sk">
        <h2 className="text-2xl font-extrabold tracking-tight text-white md:text-3xl" data-id="element-703" data-mp="2rtb8porgid2j">
          0KM disponibles para financiar
        </h2>
        <p className="mt-3 max-w-2xl text-base text-mist" data-id="element-704" data-mp="xguxe9jt08qt">
          Unidades nuevas con entrega coordinada y planes de cuotas según tu perfil.
        </p>
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-705" data-mp="skwe30dc1gx9">
          {cero.map(v => <VehicleCard key={v.id} vehicle={v} data-id="element-706" data-mp="3489cz811f4hk" />)}
        </div>
      </section>
    </main>;
}